export default {
	// ===== pages/index/index.vue =====
	index: {
		hotCategory: '热门分类',
		hotGroup: '热门共愿小组',
		wishConnect: '愿望连接',
		recommend: '为你推荐',
		viewMore: '查看更多',
		locating: '定位中...',
		clickLocate: '点击获取定位',
		viewNearby: '查看附近的愿望',
		nearbyWish: '附近愿望',
		similarCluster: '相似愿望聚类',
		loading: '加载中...',
		noMore: '没有更多了 ~',
		subjectHint: '点击参与专题许愿',
		shareTitle: '你的自律让愿望实现，来一起许愿、自律打卡吧~',
	},

	// ===== pages/publish/index.vue =====
	publish: {
		nicknamePlaceholder: '输入姓名/昵称（选填）',
		wishPlaceholder: '愿所求皆如愿，愿所行皆坦途（至少10个字）',
		locating: '定位中...',
		recording: '许愿中...',
		recordNow: '立即许愿',
		saveDraft: '保存草稿',
		aiAnalyzing: 'AI 分析中...',
		shareTo: '分享到',
		shareFriend: '分享给朋友',
		cancel: '取消',
		delivering: '愿望送达中...',
		deliverBlessing: '愿所求皆如愿，所愿皆所得',
		navTitle: '心愿记录',
		secretPlaceholder: '设置查看密码（选填）',
		savedDraft: '已保存草稿',
		tooShort: '愿望内容至少10个字',
		sensitiveWord: '愿望内容包含敏感词，请修改后重试',
		checkFailed: '内容检查失败，请重试',
		createOrderFailed: '创建订单失败',
		payIdentityFailed: '获取支付身份失败，请重试',
		payInfoFailed: '获取支付信息失败',
		payFailed: '支付失败',
		pleasePay: '请完成支付',
		publishFailed: '发布失败',
		retryPublish: '发布失败，请重试',
		payPending: '支付未完成',
		reRecord: '请重新记录心愿',
		keywordExists: '该关键词已在愿望中',
		keywordAdded: '已添加关键词：{word}',
		shareDefault: '我要许愿，愿所求皆如愿',
	},

	// ===== components/feed-card/feed-card.vue =====
	feedCard: {
		watermarkGold: '心想事成',
		watermarkSecret: '秘密心愿',
		anonymous: '匿名用户',
		followed: '已关注',
		follow: '+ 关注',
		collapse: '收起',
		expand: '全文',
		guardSuccess: '守护成功',
		followSuccess: '关注成功',
		unfollowSuccess: '取消关注成功',
	},

	// ===== pages-sub/my-wishes/my-wishes.vue =====
	myWishes: {
		title: '我的心愿',
		tabAll: '全部',
		tabGrowing: '进行中',
		tabAchieved: '已达成',
		tabArchived: '已归档',
		wishFulfill: '还愿',
		meritFull: '功德圆满',
		fulfillShort: '圆满',
		achievedStatus: '心愿已达成，福气长存',
		blessing: '感恩回馈，愿美好常在',
		noMore: '已经到底啦 ~',
		noData: '没有找到数据哦...',
		goPublish: '去许一个愿望吧',
		loading: '加载中...',
	},

	// ===== pages-sub/wish-place-list/wish-place-list.vue =====
	placeList: {
		title: '许愿圣地',
		searchPlaceholder: '搜索许愿圣地',
		advanced: '高级',
		advancedSearch: '高级搜索',
		sortBy: '排序方式',
		category: '心愿分类',
		sortDefault: '默认',
		sortDistance: '按距离远近',
		noCategory: '暂无分类数据',
		reset: '重置',
		confirm: '确定',
		noMore: '已经到底啦~',
		noData: '暂无许愿圣地数据',
		loading: '加载中...',
	},

	// ===== pages-sub/wish-place/wish-place.vue =====
	wishPlace: {
		nicknamePlaceholder: '输入姓名/昵称（选填）',
		wishPlaceholder: '愿所求皆如愿，愿所行皆坦途（至少10个字）',
		recording: '许愿中...',
		recordNow: '立即许愿',
		saveDraft: '保存草稿',
		shareTo: '分享到',
		shareFriend: '分享给朋友',
		shareTimeline: '分享到朋友圈',
		cancel: '取消',
		delivering: '愿望送达中...',
		deliverBlessing: '愿所求皆如愿，所愿皆所得',
		secretPlaceholder: '设置查看密码（选填）',
		tooShort: '愿望内容至少10个字',
		sensitiveWord: '愿望内容包含敏感词，请修改后重试',
		checkFailed: '内容检查失败，请重试',
		createOrderFailed: '创建订单失败',
		payIdentityFailed: '获取支付身份失败，请重试',
		payInfoFailed: '获取支付信息失败',
		payFailed: '支付失败',
		pleasePay: '请完成支付',
		publishFailed: '发布失败',
		retryPublish: '发布失败，请重试',
		payPending: '支付未完成',
		reRecord: '请重新发布愿望',
		savedDraft: '已保存草稿',
		shareTip: '点击右上角「...」可分享到朋友圈',
	},

	// ===== pages-sub/wish-info/wish-info.vue =====
	wishInfo: {
		title: '许愿成功',
		watermark1: '心',
		watermark2: '想',
		watermark3: '事',
		watermark4: '成',
		wish: '求',
		anonymous: '匿名用户',
		recordedBy: '此愿望由',
		recordedAt: '于',
		recorded: '记录',
		blessing: '祝您早日实现美好愿望',
		appName: '「我要许愿望」',
		recordWish: '普通愿望',
		rememberCode: '请牢记愿望编码：',
		codeHint: '凭此编码查看愿望或还愿',
		saveImage: '保存图片',
		goPlaceList: '去看看合适的许愿圣地',
		downloading: '正在下载',
		saveSuccess: '保存成功',
		loading: '加载中...',
		generating: '生成中...',
		generateFailed: '生成失败，请重试',
		needPermission: '需要授权保存到相册',
		saveFailed: '保存失败',
		exportFailed: '图片导出失败',
		dataNotLoaded: '愿望数据未加载',
		wishCode: '愿望编码：',
		brandSuffix: '愿你所愿，终能实现',
		defaultWish: '心愿',
		canvasBlessing: '祝您早日实现美好愿望',
	},

	// ===== pages-sub/wish-redeem/wish-redeem.vue =====
	wishRedeem: {
		title: '还愿',
		queryTitle: '输入许愿编码查询',
		queryPlaceholder: '请输入许愿编码',
		query: '查询',
		wish: '求',
		wishDefault: '愿望',
		selectMethod: '选择还愿方式',
		meritFull: '功德圆满',
		fulfillShort: '圆满',
		achievedStatus: '愿望实现，福气长存',
		blessing: '感恩回馈，愿美好常在',
		congrats: '恭喜心愿达成',
		agreement: '我已阅读并同意',
		agreementLink: '《许愿与还愿服务用户协议》',
		notice: '许愿与还愿均为即时履行的虚拟服务，支付完成后不支持退款',
		fulfill: '还愿',
		creating: '创建订单中...',
		querying: '查询中...',
		inputCodeFirst: '请输入愿望编码',
		notFound: '未找到该愿望',
		queryFailed: '查询失败，请重试',
		anonymous: '匿名用户',
		payIdentityFailed: '获取支付身份失败，请重试',
		payInfoFailed: '获取支付信息失败',
		payFailed: '支付失败',
		pleasePay: '请完成支付',
		createRetry: '创建订单失败，请重试',
	},

	// ===== components/wish-card/wish-card.vue =====
	wishCard: {
		watermark: '心想事成',
		difficulty: '难度',
		stageSeed: '种子期',
		stageSprout: '萌芽期',
		stageGrow: '成长期',
		stageBloom: '开花期',
		stageFruit: '结果期',
		guardSuccess: '守护成功',
	},

	// ===== components/wish-place-h-scroll/wish-place-h-scroll.vue =====
	wishPlaceHScroll: {
		title: '更多灵验之地',
		viewMore: '查看更多',
	},

	// ===== components/pay-confirm-dialog/pay-confirm-dialog.vue =====
	payConfirmDialog: {
		wishType: '许愿类型',
		secretKey: '设置查看密码',
		secretPlaceholder: '输入密码后可查看愿望',
		agreement: '我已阅读并同意',
		agreementLink: '《许愿与还愿服务用户协议》',
		notice: '许愿与还愿均为即时履行的虚拟服务，支付完成后不支持退款',
		cancel: '取消',
		confirmPay: '确认支付',
		serviceAgreement: '服务协议',
		confirmModal: '是否已阅读并同意《许愿与还愿服务用户协议》？',
		agree: '同意',
	},

	// ===== components/group-card/group-card.vue =====
	groupCard: {
		members: '成员',
		comments: '评论',
	},

	// ===== components/wish-cluster/wish-cluster.vue =====
	wishCluster: {
		title: '愿望星空',
		subtitle: '点击标签 · 探索愿望',
		hot: '热门',
		wishes: '愿望',
		participants: '参与者',
		visits: '访问数',
		enter: '进入探索',
	},

	// ===== components/limit-project-section/limit-project-section.vue =====
	limitProject: {
		title: '我的自律',
		checkedIn: '今日已打卡 ✅',
		pendingCheckIn: '今日待打卡 ⏰',
		emptyText: '愿望不会自己实现。立即添加第一个项，今天的坚持，就是明天的底气。',
		emptyAdd: '点击这里，让自律发生',
		exampleLabel: '例如',
		example1: '戒烟',
		example2: '早起',
		example3: '锻炼',
		example4: '阅读',
		collapse: '收起',
		expandAll: '展开全部 {count} 个',
		pkStatus: 'PK中 · 已打卡 {count} 天',
		unnamed: '未命名',
	},

	// ===== components/near-place-section/near-place-section.vue =====
	nearPlace: {
		title: '在这许愿',
		more: '更多许愿圣地 ›',
		goRecord: '去许愿',
		achieved: '还愿',
	},

	// ===== components/ai-analysis/ai-analysis.vue =====
	aiAnalysis: {
		title: 'AI 智能分析',
		keywords: '关键词',
		summary: '心愿摘要',
		recommendCategory: '推荐分类',
		difficulty: '难度评估',
		timeCommitment: '预计投入',
		hourPerWeek: '小时/周',
		week: '周',
		sentiment: '情感分析',
		feasibility: '可行性',
		high: '高',
		medium: '中',
		low: '低',
		unknown: '未知',
	},

	// ===== components/word-cloud/word-cloud.vue =====
	wordCloud: {
		title: '💫 大家都在许这些愿',
	},

	// ===== components/place-select-popup/place-select-popup.vue =====
	placeSelect: {
		title: '在这里许愿',
		sortDefault: '默认',
		sortDistance: '距离',
		nearest: '最近',
		loadingPlaces: '加载灵验之地...',
		noPlaces: '暂无灵验之地',
	},

	// ===== components/travel-pay-dialog/travel-pay-dialog.vue =====
	travelPayDialog: {
		goTo: '前往{place}',
		feeNotice: '网上送达需要支付费用',
		selectType: '请选择许愿类型',
		fastDelivery: '快速送达',
		expressDelivery: '飞速送达',
		goPay: '去支付',
		creating: '创建订单中...',
		payTip: '支付完成后可以进入网上地点许愿',
		placeError: '地点信息异常',
		createFailed: '创建订单失败',
		createRetry: '创建订单失败，请重试',
	},

	// ===== components/wish-place-feed/wish-place-feed.vue =====
	wishPlaceFeed: {
		tabWishes: '大家在这许愿',
		tabIntro: '心愿助手',
		anonymous: '匿名用户',
		empty: '还没有人在这里许愿，来做第一个吧~',
		loading: '加载中...',
		noIntro: '暂无介绍',
	},
}